import { Check } from 'lucide-react'
import { GAME_TYPES, getCompatibleGames, getFormatForPlayerCount, getFormatLabels } from '../../constants/gameTypes'

/**
 * Game type selection grid shared between RoundSetupWizard and SessionSetupWizard.
 *
 * Props:
 *   gameTypeId, setGameTypeId, playerCount,
 *   filterFn — optional filter applied to compatible games (e.g. team match nassau filter)
 */
export default function StepGameType({ gameTypeId, setGameTypeId, playerCount, filterFn }) {
  let compatibleGames = playerCount > 0 ? getCompatibleGames(playerCount) : GAME_TYPES
  if (filterFn) {
    compatibleGames = compatibleGames.filter(filterFn)
  }

  return (
    <div>
      <div className="form-section">
        <h3>Main Game</h3>
        {playerCount > 0 && (
          <p style={{ color: 'var(--text-muted)', fontSize: '0.75rem', margin: '0 0 0.5rem' }}>
            Showing games for {playerCount} players
          </p>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {compatibleGames.map((gt) => {
            const fmt = playerCount > 0
              ? getFormatForPlayerCount(gt, playerCount)
              : gt.teamSizes.length === 1 && gt.teamSizes[0] === 1
                ? 'Individual'
                : `Teams of ${gt.teamSizes.join(' or ')}`
            return (
            <button
              key={gt.id}
              type="button"
              onClick={() => setGameTypeId(gt.id)}
              style={{
                padding: '0.875rem 1rem',
                backgroundColor: gameTypeId === gt.id ? 'rgba(var(--accent-primary-rgb, 14, 164, 122), 0.1)' : 'var(--bg-tertiary)',
                borderRadius: '0.75rem',
                border: `1px solid ${gameTypeId === gt.id ? 'var(--accent-primary)' : 'var(--border-color)'}`,
                textAlign: 'left',
                minHeight: '48px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontWeight: '600', fontSize: '0.9375rem' }}>
                    {gt.name}
                    {fmt && <span style={{ fontWeight: '400', color: 'var(--text-muted)', marginLeft: '0.5rem', fontSize: '0.8125rem' }}>({fmt})</span>}
                  </div>
                  <div style={{ color: 'var(--text-muted)', fontSize: '0.75rem', marginTop: '0.25rem' }}>
                    {gt.description}
                  </div>
                </div>
                {gameTypeId === gt.id && <Check size={20} style={{ color: 'var(--accent-primary)', flexShrink: 0, marginLeft: '0.5rem' }} />}
              </div>
              {gameTypeId === gt.id && (
                <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid var(--border-color)' }}>
                  <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {gt.rules.map((rule, i) => (
                      <li key={i} style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', padding: '0.125rem 0', display: 'flex', gap: '0.375rem' }}>
                        <span style={{ color: 'var(--accent-primary)' }}>-</span> {rule}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
